import { render, staticRenderFns } from "./AssetPreview.vue?vue&type=template&id=5673168b&scoped=true"
import script from "./AssetPreview.vue?vue&type=script&lang=js"
export * from "./AssetPreview.vue?vue&type=script&lang=js"
import style0 from "./AssetPreview.vue?vue&type=style&index=0&id=5673168b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673168b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5673168b')) {
      api.createRecord('5673168b', component.options)
    } else {
      api.reload('5673168b', component.options)
    }
    module.hot.accept("./AssetPreview.vue?vue&type=template&id=5673168b&scoped=true", function () {
      api.rerender('5673168b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/AssetPreview.vue"
export default component.exports